import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import backButton from "../assets/backButton.svg";
import { Country, State } from "country-state-city";
import { decryptData, retrieveData } from "../LocalConnection/LocalConnection";

import {
  handleError,
  validateEmail,
  validateMobileplus,
  handleEmailChange,
} from "../CommonJquery/CommonJquery";
import {
  sava_onboarding_form,
  save_onboarding,
  get_last_resturant,
  server_post_data,
  send_otp_for_pos_onboarding,
} from "../ServiceConnection/serviceconnection";

let default_restaurant_id_staff_new = "0";

const Onboadingstep1 = ({resnewid, nextStep, prevStep, initialData, saveData }) => {
  default_restaurant_id_staff_new = resnewid;


  const [showLoader, setshowLoader] = useState(false);
  const [showLoaderAdmin, setshowLoaderAdmin] = useState(false);
  const [states, setStates] = useState([]);
  const [showButton, setShowButton] = useState(true);
  const [showButton1, setShowButton1] = useState(true);
  const [countdown, setCountdown] = useState(60);
  const [countdown1, setCountdown1] = useState(60);
  const [showEditButton, setShowEditButton] = useState(false);
  const [showEditButton1, setShowEditButton1] = useState(false);

  // FIX: keep interval ids in refs so we can clear them (avoids
  // "state update on unmounted component" warnings + leaked timers)
  const countdownIntervalRef = useRef(null);
  const countdownIntervalRef1 = useRef(null);

  const [address, setAddress] = useState({
    email: "",
    OTP_email: "",
    location: "",
    street: "",
    country: "",
    city: "",
    state: "",
    zip: "",
    contactNumber: "",
    OTP_STATUS: false,
    OTP_ENTER: false,
    OTP_ERORR: false,
    OTP_value: "",
    OTP_come: "",
    OTP_STATUS1: false,
    OTP_ENTER1: false,
    OTP_ERORR1: false,
    OTP_value1: "",
    OTP_come1: "",
    countryCode: "+91",
  });

  const [errors, setErrors] = useState({});
  const [shake, setShake] = useState(false);
  const [focusedField, setFocusedField] = useState(null);
  const [restaurantData, setrestaurantData] = useState([]);
  const [countries, setCountries] = useState([]);
  const [isFormValid, setIsFormValid] = useState(false);

  // FIX: custom searchable dropdowns for Country/State, matching the
  // pattern already used on the Analytics dashboard's restaurant filter —
  // avoids react-select's portal/clipping issues entirely.
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [countrySearch, setCountrySearch] = useState("");
  const countryDropdownRef = useRef(null);

  const [showStateDropdown, setShowStateDropdown] = useState(false);
  const [stateSearch, setStateSearch] = useState("");
  const stateDropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setShowCountryDropdown(false);
        setCountrySearch("");
      }
      if (
        stateDropdownRef.current &&
        !stateDropdownRef.current.contains(event.target)
      ) {
        setShowStateDropdown(false);
        setStateSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const filteredCountries =
    countries && countries.length > 0
      ? countries.filter((c) =>
          c.label.toLowerCase().includes(countrySearch.toLowerCase()),
        )
      : [];

  const filteredStates =
    states && states.length > 0
      ? states.filter((s) =>
          s.label.toLowerCase().includes(stateSearch.toLowerCase()),
        )
      : [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    let value_ddd = value;
    if (name === "countryCode") {
      value_ddd = validateMobileplus(value);
    }
    setAddress((prev) => ({ ...prev, [name]: value_ddd }));
    if (value_ddd.trim() !== "") {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  // FIX: Improved pincode handler - doesn't clear street address
  const handlezipcodeChange = async (e) => {
    const zipCode = e.target.value;

    // Update ZIP/PIN code immediately
    setAddress((prevAddress) => ({
      ...prevAddress,
      zip: zipCode,
    }));

    if (zipCode.length !== 6 || !/^\d+$/.test(zipCode)) {
      return;
    }

    try {
      const response = await axios.get(
        `https://api.postalpincode.in/pincode/${zipCode}`,
      );

      if (response.data && response.data[0].Status === "Success") {
        const postOffices = response.data[0].PostOffice;
        const postOffice = postOffices[0];

        // Better data extraction
        const city = postOffice.District || postOffice.Block || "";
        const state = postOffice.State || "";
        const country = "India";

        // IMPORTANT: Only update location fields, NOT street or location
        setAddress((prevAddress) => ({
          ...prevAddress,
          country: country,
          state: state,
          city: city,
          // street and location remain unchanged
        }));
      } else {
        handleError("Invalid PIN code. Please check and try again.");

        setAddress((prevAddress) => ({
          ...prevAddress,
          city: "",
          state: "",
          country: "",
          // Don't clear street and location
        }));
      }
    } catch (error) {
      console.error("Error fetching location data:", error.message);
      handleError("Unable to fetch location. Please enter manually.");

      setAddress((prevAddress) => ({
        ...prevAddress,
        city: "",
        state: "",
        country: "",
        // Don't clear street and location
      }));
    }
  };

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  // FIX: Improved validation logic
  const handleNextStep = () => {
    const newErrors = {};
    let hasError = false;

    // Check email
    if (!address.email || !validateEmailFormat(address.email)) {
      newErrors["email"] = true;
      hasError = true;
    }

    // Check phone OTP verification
    if (address["OTP_STATUS"] !== true) {
      newErrors["contactNumber_OTP"] = true;
      hasError = true;
    }

    // Check email OTP verification
    if (address["OTP_STATUS1"] !== true) {
      newErrors["contactNumber_OTP1"] = true;
      hasError = true;
    }

    // Check other required fields
    const requiredFields = [
      "location",
      "street",
      "country",
      "city",
      "state",
      "zip",
      "contactNumber",
    ];
    requiredFields.forEach((field) => {
      if (!address[field] || address[field].toString().trim() === "") {
        newErrors[field] = true;
        hasError = true;
      }
    });

    if (hasError) {
      setErrors(newErrors);
      setShake(true);
      setTimeout(() => setShake(false), 500);
    } else {
      setErrors(newErrors);
      // Save data before proceeding
      if (saveData) {
        saveData(address);
      }
      // Also save to localStorage as backup (scoped to this restaurant)
      localStorage.setItem(getOnboardingStorageKey(), JSON.stringify(address));
      handleSaveChangesdynamic();
    }
  };

  const handleOTPverify = () => {
    const newErrors = {};
    let hasError = false;

    if (
      address["contactNumber"] === null ||
      address["contactNumber"] === "" ||
      address["contactNumber"].length < 10
    ) {
      newErrors["contactNumber"] = true;
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      setShake(true);
      setTimeout(() => setShake(false), 500);
    } else {
      takeotpfromserver(0);
      startCountdown(0);
    }
  };

  const validateEmailFormat = (email) => {
    const emailParts = email.split("@");
    return (
      emailParts.length === 2 &&
      emailParts[1].includes(".") &&
      /^[a-zA-Z0-9._@-]*$/.test(email)
    );
  };

  const handleEmailVarfy = () => {
    const newErrors = {};
    let hasError = false;

    if (
      address["email"] === null ||
      address["email"] === "" ||
      address["email"].length < 9
    ) {
      newErrors["email"] = true;
      hasError = true;
    } else if (!validateEmailFormat(address.email)) {
      newErrors["email"] = true;
      hasError = true;
    }

    if (hasError) {
      setErrors(newErrors);
      setShake(true);
      setTimeout(() => setShake(false), 500);
    } else {
      takeotpfromserver(1);
      startCountdown(1);
    }
  };

  // FIX: store interval ids so they can be cleared (on retrigger or unmount)
  const startCountdown = (flag) => {
    if (flag == 1) {
      if (countdownIntervalRef1.current)
        clearInterval(countdownIntervalRef1.current);
      setShowButton1(false);
      setCountdown1(60);
      countdownIntervalRef1.current = setInterval(() => {
        setCountdown1((prev) => {
          if (prev <= 1) {
            clearInterval(countdownIntervalRef1.current);
            setShowButton1(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    } else {
      if (countdownIntervalRef.current)
        clearInterval(countdownIntervalRef.current);
      setShowButton(false);
      setCountdown(60);
      countdownIntervalRef.current = setInterval(() => {
        setCountdown((prev) => {
          if (prev <= 1) {
            clearInterval(countdownIntervalRef.current);
            setShowButton(true);
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
  };

  // FIX: clear any running countdown intervals on unmount
  useEffect(() => {
    return () => {
      if (countdownIntervalRef.current)
        clearInterval(countdownIntervalRef.current);
      if (countdownIntervalRef1.current)
        clearInterval(countdownIntervalRef1.current);
    };
  }, []);

  const formatCountdown = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const handleSaveChangesdynamic = async () => {
    setshowLoader(true);
    const form_data = new FormData();
    form_data.append(
      "default_restaurant_id_staff_new",
      default_restaurant_id_staff_new,
    );
    form_data.append("restaurant_full_adrress", address.location);
    form_data.append("restaurant_temorary_adrress", address.street);
    form_data.append("restaurant_city", address.city);
    form_data.append("restaurant_state", address.state);
    form_data.append("restaurant_country", address.country);
    form_data.append("restaurant_zipcode", address.zip);
    form_data.append("restaurant_email", address.email);
    form_data.append("restaurant_mobile_no", address.contactNumber);
    form_data.append("restaurant_country_code", address.countryCode);
    form_data.append("step_save", "1");

    await server_post_data(save_onboarding, form_data)
      .then(async (Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          nextStep();
        }
        setshowLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoader(false);
      });
  };

  const takeotpfromserver = async (flag) => {
    setshowLoader(true);
    const form_data = new FormData();
    form_data.append(
      "default_restaurant_id_staff_new",
      default_restaurant_id_staff_new,
    );
    form_data.append("restaurant_mobile_no", address.contactNumber);
    form_data.append("restaurant_email", address.email);
    form_data.append("restaurant_country_code", address.countryCode);
    form_data.append("flag", flag);

    await server_post_data(send_otp_for_pos_onboarding, form_data)
      .then(async (Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          const staff_otp = decryptData(Response.data.message);
          if (flag === 0) {
            setAddress((prev) => ({
              ...prev,
              ["OTP_come"]: staff_otp.staff_otp,
              ["OTP_ENTER"]: true,
              ["OTP_STATUS"]: false, // Will be true only after verification
              ["OTP_ERORR"]: false,
            }));
          } else if (flag === 1) {
            setAddress((prev) => ({
              ...prev,
              ["OTP_come1"]: staff_otp.staff_otp,
              ["OTP_ENTER1"]: true,
              ["OTP_STATUS1"]: false, // Will be true only after verification
              ["OTP_ERORR1"]: false,
            }));
          }
        }
        setshowLoader(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoader(false);
      });
  };

  // FIX: the localStorage draft key was a single generic string shared by
  // EVERY restaurant. Starting a new restaurant's onboarding would silently
  // restore stale address/contact data left over from a previously
  // onboarded restaurant — even though `get_last_resturant` correctly
  // returns null fields for the new one. Scoping the key to
  // default_restaurant_id_staff_new fixes that.
  const getOnboardingStorageKey = () =>
    `onboarding_step1_data_${default_restaurant_id_staff_new}`;

  // FIX: Load data on mount (from props or localStorage or API)
  useEffect(() => {
    // one-time cleanup of the old unscoped key so it can't keep leaking
    // into future restaurants
    localStorage.removeItem("onboarding_step1_data");

    // Priority 1: Check if data passed from parent
    if (initialData) {
      setAddress(initialData);
      return;
    }

    // Priority 2: Check localStorage (scoped to THIS restaurant only)
    const savedData = localStorage.getItem(getOnboardingStorageKey());
    if (savedData) {
      try {
        const parsedData = JSON.parse(savedData);
        setAddress((prevAddress) => ({
          ...prevAddress,
          ...parsedData,
        }));
        return;
      } catch (e) {
        console.error("Error parsing saved data:", e);
      }
    }

    // Priority 3: Load from API
    master_data_get();
  }, []);

  const master_data_get = async () => {
    setshowLoaderAdmin(true);
    const form_data = new FormData();
    form_data.append(
      "default_restaurant_id_staff_new",
      default_restaurant_id_staff_new,
    );

    await server_post_data(get_last_resturant, form_data)
      .then((Response) => {
        if (Response.data.error) {
          handleError(Response.data.message);
        } else {
          if (Response.data.message.restaurant_data.length > 0) {
            setrestaurantData(Response.data.message.restaurant_data[0]);
            setAddress({
              email:
                Response.data.message.restaurant_data[0].restaurant_email || "",
              location:
                Response.data.message.restaurant_data[0]
                  .restaurant_full_adrress || "",
              street:
                Response.data.message.restaurant_data[0]
                  .restaurant_temorary_adrress || "",
              country:
                Response.data.message.restaurant_data[0].restaurant_country ||
                "",
              city:
                Response.data.message.restaurant_data[0].restaurant_city || "",
              state:
                Response.data.message.restaurant_data[0].restaurant_state || "",
              zip:
                Response.data.message.restaurant_data[0].restaurant_zipcode ||
                "",
              contactNumber:
                Response.data.message.restaurant_data[0].restaurant_mobile_no ||
                "",
              countryCode:
                Response.data.message.restaurant_data[0]
                  .restaurant_country_code !== null
                  ? Response.data.message.restaurant_data[0]
                      .restaurant_country_code
                  : "+91",
              OTP_come: "",
              OTP_ENTER: false,
              OTP_STATUS: false,
              OTP_ERORR: false,
              OTP_come1: "",
              OTP_ENTER1: false,
              OTP_STATUS1: false,
              OTP_ERORR1: false,
            });
          }
        }
        setshowLoaderAdmin(false);
      })
      .catch((error) => {
        console.log(error);
        setshowLoaderAdmin(false);
      });
  };

  useEffect(() => {
    const allCountries = Country.getAllCountries();
    setCountries(
      allCountries.map((country) => ({
        value: country.isoCode,
        label: country.name,
      })),
    );
  }, []);

  // FIX (main dropdown bug): whenever address.country changes — whether from
  // manual selection, API load, localStorage, initialData, or the pincode
  // lookup — resolve its ISO code against the loaded `countries` list and
  // (re)populate `states`. Previously this only happened inside
  // handleCountryChange, so any country that arrived from a source other
  // than the dropdown left the State <Select> with an empty options list.
  useEffect(() => {
    if (address.country && countries.length > 0) {
      const matchedCountry = countries.find(
        (c) => c.label === address.country || c.value === address.country,
      );
      if (matchedCountry) {
        const allStates = State.getStatesOfCountry(matchedCountry.value);
        setStates(
          allStates.map((state) => ({
            value: state.isoCode,
            label: state.name,
          })),
        );
      }
    } else if (!address.country) {
      setStates([]);
    }
  }, [address.country, countries]);

  useEffect(() => {
    const {
      email,
      location,
      street,
      country,
      city,
      state,
      zip,
      contactNumber,
      OTP_STATUS,
      OTP_STATUS1,
    } = address;

    const isFilled =
      email &&
      location &&
      street &&
      country &&
      city &&
      state &&
      zip &&
      contactNumber &&
      OTP_STATUS === true &&
      OTP_STATUS1 === true;

    setIsFormValid(isFilled);
  }, [address]);

  // FIX: selecting a country resets state (unchanged behavior) and closes
  // the custom dropdown + clears its search box.
  const handleCountrySelect = (option) => {
    setAddress((prevAddress) => ({
      ...prevAddress,
      country: option.label,
      state: "",
    }));
    setShowCountryDropdown(false);
    setCountrySearch("");
    setErrors((prev) => ({ ...prev, country: false }));
  };

  const handleStateSelect = (option) => {
    setAddress((prevAddress) => ({
      ...prevAddress,
      state: option.label,
    }));
    setShowStateDropdown(false);
    setStateSearch("");
    setErrors((prev) => ({ ...prev, state: false }));
  };

  const handleMobilevalidation = (e) => {
    const { name, value } = e.target;

    if (name === "contactNumber" && !/^\d*$/.test(value)) {
      return;
    }
    if (name === "OTP_value" && !/^\d*$/.test(value)) {
      return;
    }

    handleChange(e);
  };

  // FIX: Improved OTP verification for mobile (comment now matches the
  // actual 4-digit OTP length used everywhere else)
  const handleVerifyOTPMobile = (e) => {
    const enteredOTP = e.target.value;
    const correctOTP = address["OTP_come"];

    // Update OTP_value in state
    setAddress((prev) => ({
      ...prev,
      OTP_value: enteredOTP,
    }));

    // Only verify when OTP is complete (4 digits)
    if (enteredOTP.length === 4) {
      if (parseInt(enteredOTP) === parseInt(correctOTP)) {
        setAddress((prev) => ({
          ...prev,
          OTP_ENTER: false,
          OTP_STATUS: true, // Mark as verified
          otpVerified: true,
        }));
        setShowEditButton(true);
        setErrors((prev) => ({
          ...prev,
          OTP_ERORRRRRR: false,
          contactNumber_OTP: false,
        }));
      } else {
        setAddress((prev) => ({
          ...prev,
          OTP_STATUS: false,
        }));
        setErrors((prev) => ({ ...prev, OTP_ERORRRRRR: true }));
      }
    } else if (enteredOTP.length === 0) {
      // Clear error if user clears the field
      setErrors((prev) => ({ ...prev, OTP_ERORRRRRR: false }));
    }
  };

  const handleMobileEdit = () => {
    setShowEditButton(false);
    setShowButton(true);
    setAddress((prev) => ({
      ...prev,
      OTP_value: "",
      OTP_come: "",
      otpVerified: false,
      OTP_ENTER: false,
      OTP_STATUS: false,
    }));
    setErrors((prev) => ({ ...prev, OTP_ERORRRRRR: false }));
  };

  const handleEmailValidation = (e) => {
    const { name, value } = e.target;

    setAddress((prev) => ({ ...prev, [name]: value }));
    if (value.trim() !== "") {
      setErrors((prev) => ({ ...prev, [name]: false }));
    }
  };

  // FIX: Improved OTP verification for email (comment now matches the
  // actual 4-digit OTP length used everywhere else)
  const handleOtpChange = (e) => {
    const enteredOTP = e.target.value;
    const correctOTP = address["OTP_come1"];

    // Update OTP_value1 in state
    setAddress((prev) => ({
      ...prev,
      OTP_value1: enteredOTP,
    }));

    // Only verify when OTP is complete (4 digits)
    if (enteredOTP.length === 4) {
      if (parseInt(enteredOTP) === parseInt(correctOTP)) {
        setAddress((prev) => ({
          ...prev,
          OTP_ENTER1: false,
          OTP_STATUS1: true, // Mark as verified
          otpVerified1: true,
        }));
        setShowEditButton1(true);
        setErrors((prev) => ({
          ...prev,
          OTP_ERORRRRRR1: false,
          contactNumber_OTP1: false,
        }));
      } else {
        setAddress((prev) => ({
          ...prev,
          OTP_STATUS1: false,
        }));
        setErrors((prev) => ({ ...prev, OTP_ERORRRRRR1: true }));
      }
    } else if (enteredOTP.length === 0) {
      // Clear error if user clears the field
      setErrors((prev) => ({ ...prev, OTP_ERORRRRRR1: false }));
    }
  };

  const handleEdit = () => {
    setShowEditButton1(false);
    setShowButton1(true);
    setAddress((prev) => ({
      ...prev,
      OTP_value1: "",
      OTP_come1: "",
      otpVerified1: false,
      OTP_ENTER1: false,
      OTP_STATUS1: false,
    }));
    setErrors((prev) => ({ ...prev, OTP_ERORRRRRR1: false }));
  };

  return (
    <div className="containerRight gap-0">
      <div className="rightHeading">
        <div className="d-flex BackHeading">
          <button onClick={prevStep}>
            <img src={backButton} alt="backButton" />
          </button>
          <h3>Enter your restaurant address</h3>
        </div>
        <p>Add a location where customers can visit you</p>
      </div>
      <div className="overflowHeightstep1">
        <div
          className="step1Contrr"
          style={{
            paddingTop: "0.4rem",
            overflow: "auto",
            height: Object.values(errors).some((error) => error)
              ? "calc(100vh + 220px)"
              : showCountryDropdown || showStateDropdown
                ? "calc(100vh + 130px)"
                : "calc(100vh + 30px)",
          }}
        >
          <div className="col-sm-9 mb-3">
            <div className="row">
              <div className="col-3" style={{ position: "relative" }}>
                <input
                  type="text"
                  name="countryCode"
                  placeholder="+91"
                  maxLength={5}
                  value={address.countryCode}
                  className={`form-control ${
                    errors.countryCode ? "input-error" : ""
                  } ${shake ? "shake" : ""} ${
                    focusedField === "countryCode" ? "input-focus" : ""
                  }`}
                  onFocus={() => handleFocus("countryCode")}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  readOnly
                />
                {errors.countryCode && (
                  <span className="error-message">
                    Country code is required
                  </span>
                )}
              </div>
              <div
                className="col-sm-9 pdingClss"
                style={{ position: "relative" }}
              >
                {(focusedField === "contactNumber" ||
                  address.contactNumber) && (
                  <label className="HeadBussiness">Phone Number*</label>
                )}
                <div
                  className={`mobileCOntnt ${
                    focusedField === "contactNumber" ? "input-focus" : ""
                  }`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    border: address.otpVerified ? "1px solid green" : "",
                    position: "relative",
                  }}
                >
                  <input
                    type="text"
                    minLength={10}
                    maxLength={10}
                    value={address.contactNumber}
                    name="contactNumber"
                    placeholder="Phone Number*"
                    className={`form-control ActiveFormCOntrol ${
                      errors.contactNumber ? "input-error" : ""
                    } ${shake ? "shake" : ""}`}
                    onFocus={() => handleFocus("contactNumber")}
                    onBlur={handleBlur}
                    onChange={handleMobilevalidation}
                    readOnly={address.otpVerified}
                    style={{
                      opacity: address.otpVerified ? 0.5 : 1,
                    }}
                  />

                  {showEditButton ? (
                    <button type="button" onClick={handleMobileEdit}>
                      Edit
                    </button>
                  ) : (
                    <>
                      <button
                        type="button"
                        style={{ display: showButton ? "flex" : "none" }}
                        onClick={() => handleOTPverify()}
                      >
                        Get OTP
                      </button>
                      {!showButton && (
                        <button type="button" style={{ cursor: "text" }}>
                          {formatCountdown(countdown)}
                        </button>
                      )}
                    </>
                  )}
                </div>

                {errors.contactNumber_OTP && (
                  <span className="error-message">
                    Verification is required
                  </span>
                )}

                {errors.contactNumber && (
                  <span className="error-message">
                    Phone number is required
                  </span>
                )}
              </div>
            </div>
          </div>

          {address.OTP_ENTER && (
            <div className="col-sm-9 mb-3" style={{ position: "relative" }}>
              {focusedField === "OTP_value" && (
                <label className="HeadBussiness">OTP Number*</label>
              )}
              <div
                className={`mobileCOntnt ${
                  focusedField === "OTP_value" ? "input-focus" : ""
                }`}
                style={{ display: "flex", alignItems: "center" }}
              >
                <input
                  type="text"
                  minLength={4}
                  maxLength={4}
                  value={address.OTP_value || ""}
                  name="OTP_value"
                  placeholder="Enter 4-digit OTP*"
                  className={`form-control ActiveFormCOntrol ${
                    errors.OTP_value ? "input-error" : ""
                  } ${shake ? "shake" : ""}`}
                  style={{ flex: 1 }}
                  onFocus={() => handleFocus("OTP_value")}
                  onBlur={handleBlur}
                  onChange={(e) => {
                    handleVerifyOTPMobile(e);
                  }}
                />
              </div>
              {errors.OTP_ERORRRRRR && (
                <span className="error-message">
                  Incorrect OTP. Please try again.
                </span>
              )}
              {address.OTP_STATUS === true && (
                <span className="successMessage">
                  ✓ OTP Verified Successfully
                </span>
              )}
            </div>
          )}

          {/**----------------Email Validation--------------- */}
          <div className="col-sm-9 mb-3" style={{ position: "relative" }}>
            {(focusedField === "email" || address.email) && (
              <label className="HeadBussiness">Restaurant Email ID*</label>
            )}
            <div
              className={`mobileCOntnt emailContr ${
                focusedField === "email" ? "input-focus" : ""
              } `}
              style={{
                display: "flex",
                alignItems: "center",
                border: address.otpVerified1 ? "1px solid green" : "",
                position: "relative",
              }}
            >
              <input
                type="text"
                name="email"
                placeholder="Restaurant Email ID*"
                className={`form-control ActiveFormCOntrol ${
                  errors.email ? "input-error" : ""
                } ${shake ? "shake" : ""}`}
                value={address.email}
                onFocus={() => setFocusedField("email")}
                onChange={(e) =>
                  setAddress({ ...address, email: e.target.value })
                }
                onBlur={handleBlur}
                readOnly={address.otpVerified1}
                style={{
                  opacity: address.otpVerified1 ? 0.5 : 1,
                }}
              />

              {showEditButton1 ? (
                <button type="button" onClick={handleEdit}>
                  Edit
                </button>
              ) : (
                <>
                  <button
                    type="button"
                    style={{ display: showButton1 ? "flex" : "none" }}
                    onClick={() => handleEmailVarfy()}
                  >
                    Get OTP
                  </button>
                  {!showButton1 && (
                    <button type="button" style={{ cursor: "text" }}>
                      {formatCountdown(countdown1)}
                    </button>
                  )}
                </>
              )}
            </div>
            {errors.contactNumber_OTP1 && (
              <span className="error-message">Verification is required</span>
            )}
            {errors.email && (
              <span className="error-message">Valid email is required</span>
            )}

            {address.OTP_ENTER1 && (
              <div className="col-sm-12 mt-3" style={{ position: "relative" }}>
                {focusedField === "OTP_value1" && (
                  <label className="HeadBussiness">OTP Number*</label>
                )}
                <div
                  className={`mobileCOntnt ${
                    focusedField === "OTP_value1" ? "input-focus" : ""
                  }`}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <input
                    type="text"
                    minLength={4}
                    maxLength={4}
                    value={address.OTP_value1 || ""}
                    name="OTP_value1"
                    placeholder="Enter 4-digit OTP"
                    className={`form-control ActiveFormCOntrol ${
                      errors.OTP_value1 ? "input-success" : ""
                    } ${shake ? "shake" : ""}`}
                    style={{ flex: 1 }}
                    onFocus={() => handleFocus("OTP_value1")}
                    onBlur={handleBlur}
                    onChange={handleOtpChange}
                  />
                </div>
                {errors.OTP_ERORRRRRR1 && (
                  <span className="error-message">
                    Incorrect OTP. Please try again.
                  </span>
                )}
                {address.OTP_STATUS1 === true && (
                  <span className="successMessage">
                    ✓ OTP Verified Successfully
                  </span>
                )}
              </div>
            )}
          </div>

          <div className="col-sm-9 mb-3" style={{ position: "relative" }}>
            {(focusedField === "location" || address.location) && (
              <label className="HeadBussiness">Location Address*</label>
            )}
            <div className="mobileCOntnt">
              {/* FIX: value is now raw (no split/map/join transform on every
                  keystroke) — that was resetting the cursor to the end of
                  the field on every render. Visual capitalization is done
                  purely with CSS now, so typing/editing mid-word works. */}
              <input
                type="text"
                placeholder="Restaurant Location"
                minLength={5}
                maxLength={100}
                name="location"
                className={`form-control  ${
                  errors.location ? "input-error" : ""
                } ${shake ? "shake" : ""} ${
                  focusedField === "location" ? "input-focused" : ""
                }`}
                style={{ textTransform: "capitalize" }}
                value={address.location}
                onFocus={() => handleFocus("location")}
                onBlur={handleBlur}
                onChange={handleChange}
              />
            </div>
            {errors.location && (
              <span className="error-message">Location is required</span>
            )}
          </div>

          <div className="col-sm-9 mb-3" style={{ position: "relative" }}>
            {(focusedField === "street" || address.street) && (
              <label className="HeadBussiness">Street Address*</label>
            )}
            <input
              type="text"
              name="street"
              placeholder="Street Address"
              minLength={10}
              maxLength={150}
              className={`form-control ${errors.street ? "input-error" : ""} ${
                shake ? "shake" : ""
              } ${focusedField === "street" ? "input-focused" : ""}`}
              style={{ textTransform: "capitalize" }}
              value={address.street}
              onFocus={() => handleFocus("street")}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {errors.street && (
              <span className="error-message">Street address is required</span>
            )}
          </div>

          <div
            className="col-sm-9 mb-3"
            style={{ position: "relative" }}
            ref={countryDropdownRef}
          >
            {(focusedField === "country" || address.country) && (
              <label className="HeadBussiness">Country*</label>
            )}
            <button
              type="button"
              className={`form-control CountryNameE ${errors.country ? "input-error" : ""}`}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                textAlign: "left",
                background: "#fff",
                cursor: "pointer",
                width: "100%",
              }}
              onClick={() => {
                setShowCountryDropdown((prev) => !prev);
                setShowStateDropdown(false);
              }}
            >
              <span style={{ color: address.country ? "#212529" : "#6c757d" }}>
                {address.country || "Select Country"}
              </span>
              <span
                style={{
                  transition: "transform 0.2s",
                  transform: showCountryDropdown
                    ? "rotate(180deg)"
                    : "rotate(0deg)",
                }}
              >
                ▾
              </span>
            </button>

            {showCountryDropdown && (
              <div
                style={{
                  position: "absolute",
                  top: "100%",
                  left: 0,
                  right: 0,
                  marginTop: "4px",
                  background: "#fff",
                  border: "1px solid #e0e0e0",
                  borderRadius: "6px",
                  boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                  zIndex: 999,
                }}
              >
                <input
                  type="text"
                  placeholder="Search country..."
                  value={countrySearch}
                  onChange={(e) => setCountrySearch(e.target.value)}
                  autoFocus
                  style={{
                    width: "100%",
                    padding: "8px 12px",
                    border: "none",
                    borderBottom: "1px solid #eee",
                    outline: "none",
                    boxSizing: "border-box",
                    borderRadius: "6px 6px 0 0",
                  }}
                />
                <div style={{ maxHeight: "220px", overflowY: "auto" }}>
                  {filteredCountries.length > 0 ? (
                    filteredCountries.map((option) => (
                      <div
                        key={option.value}
                        onClick={() => handleCountrySelect(option)}
                        style={{
                          padding: "8px 12px",
                          cursor: "pointer",
                          backgroundColor:
                            address.country === option.label
                              ? "#eef1ff"
                              : "#fff",
                        }}
                        onMouseEnter={(e) =>
                          (e.currentTarget.style.backgroundColor = "#f5f5f5")
                        }
                        onMouseLeave={(e) =>
                          (e.currentTarget.style.backgroundColor =
                            address.country === option.label
                              ? "#eef1ff"
                              : "#fff")
                        }
                      >
                        {option.label}
                      </div>
                    ))
                  ) : (
                    <div style={{ padding: "8px 12px", color: "#6c757d" }}>
                      No country found
                    </div>
                  )}
                </div>
              </div>
            )}
            {errors.country && (
              <span className="error-message">Country is required</span>
            )}
          </div>

          <div className="col-sm-9 mb-3" style={{ position: "relative" }}>
            {(focusedField === "city" || address.city) && (
              <label className="HeadBussiness">City*</label>
            )}
            <input
              type="text"
              name="city"
              placeholder="City"
              minLength={3}
              maxLength={85}
              className={`form-control ${errors.city ? "input-error" : ""} ${
                shake ? "shake" : ""
              } ${focusedField === "city" ? "input-focused" : ""}`}
              value={address.city}
              onFocus={() => handleFocus("city")}
              onBlur={handleBlur}
              onChange={handleChange}
            />
            {errors.city && (
              <span className="error-message">City is required</span>
            )}
          </div>

          <div className="col-sm-9 mb-3" style={{ position: "relative" }}>
            <div className="row after400Col">
              <div
                className="col-6 mb-3 stateDiv"
                style={{ position: "relative" }}
                ref={stateDropdownRef}
              >
                {(focusedField === "state" || address.state) && (
                  <label className="HeadBussiness2">State*</label>
                )}
                <button
                  type="button"
                  disabled={!address.country}
                  className={`form-control CountryNameE ${errors.state ? "input-error" : ""}`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    textAlign: "left",
                    background: "#fff",
                    cursor: address.country ? "pointer" : "not-allowed",
                    opacity: address.country ? 1 : 0.6,
                    width: "100%",
                  }}
                  onClick={() => {
                    if (!address.country) return;
                    setShowStateDropdown((prev) => !prev);
                    setShowCountryDropdown(false);
                  }}
                >
                  <span
                    style={{ color: address.state ? "#212529" : "#6c757d" }}
                  >
                    {address.state ||
                      (address.country ? "State" : "Select Country First")}
                  </span>
                  <span
                    style={{
                      transition: "transform 0.2s",
                      transform: showStateDropdown
                        ? "rotate(180deg)"
                        : "rotate(0deg)",
                    }}
                  >
                    ▾
                  </span>
                </button>

                {showStateDropdown && (
                  <div
                    style={{
                      position: "absolute",
                      top: "100%",
                      left: 0,
                      right: 0,
                      marginTop: "4px",
                      background: "#fff",
                      border: "1px solid #e0e0e0",
                      borderRadius: "6px",
                      boxShadow: "0 4px 14px rgba(0,0,0,0.15)",
                      zIndex: 999,
                    }}
                  >
                    <input
                      type="text"
                      placeholder="Search state..."
                      value={stateSearch}
                      onChange={(e) => setStateSearch(e.target.value)}
                      autoFocus
                      style={{
                        width: "100%",
                        padding: "8px 12px",
                        border: "none",
                        borderBottom: "1px solid #eee",
                        outline: "none",
                        boxSizing: "border-box",
                        borderRadius: "6px 6px 0 0",
                      }}
                    />
                    <div style={{ maxHeight: "220px", overflowY: "auto" }}>
                      {filteredStates.length > 0 ? (
                        filteredStates.map((option) => (
                          <div
                            key={option.value}
                            onClick={() => handleStateSelect(option)}
                            style={{
                              padding: "8px 12px",
                              cursor: "pointer",
                              backgroundColor:
                                address.state === option.label
                                  ? "#eef1ff"
                                  : "#fff",
                            }}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                "#f5f5f5")
                            }
                            onMouseLeave={(e) =>
                              (e.currentTarget.style.backgroundColor =
                                address.state === option.label
                                  ? "#eef1ff"
                                  : "#fff")
                            }
                          >
                            {option.label}
                          </div>
                        ))
                      ) : (
                        <div style={{ padding: "8px 12px", color: "#6c757d" }}>
                          No state found
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {errors.state && (
                  <span className="error-message">State is required</span>
                )}
              </div>

              <div
                className="col-6 zipcodeDiv"
                style={{ position: "relative" }}
              >
                {(focusedField === "zip" || address.zip) && (
                  <label className="HeadBussiness2">Zip Code*</label>
                )}
                <input
                  type="text"
                  name="zip"
                  placeholder="Zip Code"
                  className={`form-control ${errors.zip ? "input-error" : ""} ${
                    shake ? "shake" : ""
                  } ${focusedField === "zip" ? "input-focused" : ""}`}
                  value={address.zip}
                  onFocus={() => handleFocus("zip")}
                  onBlur={handleBlur}
                  minLength={4}
                  maxLength={10}
                  onChange={handlezipcodeChange}
                />
                {errors.zip && (
                  <span className="error-message">Zip code is required</span>
                )}
              </div>
            </div>
          </div>
        </div>

        <div
          className={`fixNextButton ${
            isFormValid ? "nonEmptyBttn" : "emptyFiled"
          }`}
          style={{ marginTop: "0px" }}
        >
          <div className="container-lg d-flex justify-content-end">
            <button
              onClick={handleNextStep}
              style={{
                opacity: isFormValid ? 1 : 0.5,
                cursor: "pointer",
              }}
            >
              Next
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Onboadingstep1;
